<section class="title-row">
  <h3 class="typography-sub-heading">
    {{ titleKey | translate }}
  </h3>
</section>

<can-not-edit-info>{{ text$ | async }}</can-not-edit-info>

<section class="submit-row">
  <div class="action-buttons">
    <button id="cancel-current-edit" aria-label="close" (click)="closePopUp()" mat-raised-button color="primary">
      {{ closeButtonKey | translate }}
    </button>
  </div>
</section>
